module.exports = __webpack_public_path__ + "static/sanderdoorn_1-ed845705cde77879c0285bb436656830.jpg";